import { ReactNode } from 'react';

import styles from './info-list.module.scss';

function InfoListTitle({ children }: { children: ReactNode }) {
  return <h3 className={styles.title}>{children}</h3>;
}

function InfoListContent({ children }: { children: ReactNode }) {
  return <dl className={styles.infoList}>{children}</dl>;
}

function InfoListDialog({ children }: { children: ReactNode }): ReactNode {
  return children;
}

function InfoListWrapper({ children }: { children: ReactNode }) {
  return <section className={styles.infoListWrapper}>{children}</section>;
}

export const InfoList = Object.assign(InfoListWrapper, {
  Title: InfoListTitle,
  Content: InfoListContent,
  Dialog: InfoListDialog,
});
